// Datei: /utils/scrollUtils.jsx
import settings from '../config/settings';

export const scrollToSection = (e, { mobile = false }) => {
    if (e.currentTarget.getAttribute('href')) {
      e.preventDefault(); 
    }
      
    const targetId = e.currentTarget.getAttribute('href')?.substring(1); // Entfernt das '#'
    let scrollOffset = 0;
    if (!mobile) {
      scrollOffset = settings.navBar.scrollOffset; 
    }


    if (targetId) {
      setTimeout(() => { // Verzögerung hinzufügen
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          // Berücksichtigt die Höhe des Navigationsmenüs
          const offsetTop = targetElement.offsetTop - scrollOffset; 
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      }, 100); // 100 Millisekunden Verzögerung
    } else {
      // Kein spezifisches Ziel, scrollen zum Anfang der Seite
      setTimeout(() => { // Verzögerung auch hier hinzufügen, für Konsistenz
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, 100);
    }
  };  